import { request } from '@/utils/http'

// ===================== 类型定义 =====================

/** 用户状态统计返回结构 */
export interface UserStatusCountVO {
  total: number
  enableCount: number
  disableCount: number
  pendingCount: number
}

/** 用户详情查询参数 */
export interface UserDetailRequest {
  userId: string
}

/** 用户详情返回结构 */
export interface UserDetailVO {
  id: string
  username: string
  phone: string
  email: string
  status: number  // 1-启用 0-禁用
  enterpriseId: string
  enterpriseName: string
  enterpriseNameEn?: string
  roleType: number  // 0-普通用户 1-管理员
  loginTime?: string
  dateCreated: string
}

/** 重置密码参数 */
export interface ResetPasswordRequest {
  userId: string
}

/** 重置密码返回结构 */
export interface ResetPasswordResponse {
  userId: string
  newPassword: string
  email: string
}

/** 修改用户状态参数 */
export interface UpdateUserStatusRequest {
  userId: string
  status: number  // 1-启用 0-禁用
}

/** 创建用户参数 */
export interface CreateUserRequest {
  username: string
  phone: string
  email: string
  enterpriseId: string
}

/** 创建用户返回结构 */
export interface CreateUserResponse {
  id: string
  username: string
  phone: string
  email: string
  password: string
  status: number
  enterpriseId: string
  enterpriseName: string
  dateCreated: string
}

/** 更新用户信息参数 */
export interface UpdateUserRequest {
  userId: string
  enterpriseId: string
  username: string
  phone: string
  email: string
}

/** 更新用户信息返回结构 */
export interface UpdateUserResponse {
  id: string
  username: string
  phone: string
  email: string
  status: number
  enterpriseId: string
  enterpriseName: string
  updateTime: string
}

/** 绑定企业参数 */
export interface BindEnterpriseRequest {
  userId: string
  enterpriseId: string
}

/** 绑定企业返回结构 */
export interface BindEnterpriseResponse {
  id: string
  username: string
  enterpriseId: string
  enterpriseName: string
  roleType: number
}

/** 用户分页查询参数 */
export interface UserPageRequest {
  pageNum: number
  pageSize: number
  keyword?: string
  status?: number
  enterpriseId?: string
}

/** 用户分页返回单项 */
export interface UserPageItem {
  id: string
  username: string
  phone: string
  email: string
  status: number
  enterpriseId: string
  enterpriseName: string
  enterpriseNameEn?: string
  roleType: number
  loginTime?: string
  dateCreated: string
}

/** 用户分页返回结构 */
export interface UserPageResponse {
  current: number
  size: number
  total: number
  list: UserPageItem[]
}

/** 未绑定企业的用户列表项 */
export interface UnboundUserItem {
  id: string
  username: string
  phone: string
  email: string
  status: number
  dateCreated: string
  loginTime: string
}

// ===================== 接口实现 =====================

/**
 * 用户状态统计
 */
export const fetchUserStatusCount = () => {
  return request.post<UserStatusCountVO>('/enterprise/tenant/clientUser/userStatusCount')
}

/**
 * 重置用户密码
 */
export const resetUserPassword = (params: ResetPasswordRequest) => {
  return request.post<ResetPasswordResponse>('/enterprise/tenant/clientUser/resetPassword', params)
}

/**
 * 修改用户状态
 */
export const updateUserStatus = (params: UpdateUserStatusRequest) => {
  return request.post<boolean>('/enterprise/tenant/clientUser/status', params)
}

/**
 * 创建企业用户
 */
export const createUser = (params: CreateUserRequest) => {
  return request.post<CreateUserResponse>('/enterprise/tenant/clientUser/create', params)
}

/**
 * 更新用户信息
 */
export const updateUser = (params: UpdateUserRequest) => {
  return request.post<UpdateUserResponse>('/enterprise/tenant/clientUser/update', params)
}

/**
 * 绑定企业
 */
export const bindEnterprise = (params: BindEnterpriseRequest) => {
  return request.post<BindEnterpriseResponse>('/enterprise/tenant/clientUser/bindEnterprise', params)
}

/**
 * 用户分页查询
 */
export const fetchUserPage = (params: UserPageRequest) => {
  return request.post<UserPageResponse>('/enterprise/tenant/clientUser/page', params)
}

/**
 * 查询未绑定企业的用户列表
 */
export const fetchUnboundUserList = () => {
  return request.post<UnboundUserItem[]>('/enterprise/tenant/clientUser/unboundList')
}
